'use client';

import { FundPageContent } from '../components/FundPageContent';

export default function NeedsFundingPage() {
  return <FundPageContent marketplaceTab="needs-funding" />;
}
